import { animateHeroElement } from './helpers';
import { gsap } from 'gsap';

export const productArchiveHeroAnimation = () => {
	const productArchiveTitle = document.querySelector(
		'.product-archive-title'
	);
	if (productArchiveTitle) {
		gsap.fromTo(
			productArchiveTitle,
			{ y: 50, opacity: 0 },
			{
				y: 0,
				opacity: 1,
				duration: 0.6,
				delay: 1.2,
				ease: 'buttonEasing',
			}
		);
	}
	const productArchiveDescription = document.querySelector(
		'.product-archive-description'
	);
	if (productArchiveDescription) {
		gsap.fromTo(
			productArchiveDescription,
			{ y: 50, opacity: 0 },
			{
				y: 0,
				opacity: 1,
				duration: 0.714,
				delay: 1.4,
				ease: 'buttonEasing',
			}
		);
	}
	const productArchiveFilters = document.querySelector(
		'.product-archive-filters'
	);
	if (productArchiveFilters) {
		gsap.fromTo(
			productArchiveFilters,
			{ y: 50, opacity: 0 },
			{
				y: 0,
				opacity: 1,
				duration: 0.6,
				delay: 1.6,
				ease: 'buttonEasing',
			}
		);
	}

	animateHeroElement(
		'.product-archive-hero-left',
		{ rotate: -10 },
		{ x: 34, y: 22, rotate: 0, duration: 1.5, ease: 'imageEasing' }
	);

	animateHeroElement(
		'.product-archive-hero-left-circle',
		{},
		{
			x: 46,
			y: 49,
			duration: 1.5,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.product-archive-hero-left-square',
		{ rotate: -10 },
		{
			rotate: 0,
			x: 62,
			y: 48,
			duration: 1.5,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.product-archive-hero-right',
		{ rotate: 0 },
		{ x: -53, y: -39, rotate: 10, duration: 1.5, ease: 'imageEasing' }
	);

	animateHeroElement(
		'.product-archive-hero-right-square',
		{ rotate: -10 },
		{
			rotate: 0,
			x: -40,
			y: -28,
			duration: 1,
			delay: 0.5,
			ease: 'imageEasing',
		}
	);
};
